import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassportDetailsComponent } from '../passport-details/passport-details.component';
import { Router } from '@angular/router';
import { PassportDetailsStore } from '../shared/passport-details.store';
import { UiStateService } from '../shared/ui-state.service';
import { BasePassportCellComponent } from '../shared/base-passport-cell.component';

@Component({
  selector: 'app-transloading-passport-cell',
  standalone: true,
  imports: [CommonModule, PassportDetailsComponent],
  templateUrl: '../shared/passport-cell.template.html',
  styleUrl: './transloading-passport-cell.component.css'
})
export class TransloadingPassportCellComponent extends BasePassportCellComponent {
  protected get personaName(): string {
    return 'transloading';
  }

  constructor(router: Router, details: PassportDetailsStore, ui: UiStateService) {
    super(router, details, ui);
  }

  /**
   * Override to exclude bulkerNumber and haulier for transloading
   */
  protected override getDetailsData(id: string): any {
    return {
      id,
      loadNumber: this.loadNumber,
      origin: this.origin,
      destination: this.destination,
      vendorName: this.vendorName,
      vendorNumber: this.vendorNumber,
      apnName: this.apnName
    };
  }

  /**
   * Override primary label - shows 'Add' for pending, 'View' for others
   */
  override get detailsPrimaryLabel(): 'Add' | 'View' {
    return this.status === 'pending' ? 'Add' : 'View';
  }

  /**
   * Override to hide passport complete button for transloading
   */
  override get detailsHidePassportComplete(): boolean {
    return true;
  }
}


